import { Button, Col, Row } from 'antd';
import React, { ReactElement, useState } from 'react';
import PageHeader from '../../../../shared/components/pageHeader/PageHeader';
import { extractSecondLevelBaseUrl } from '../../../../utils/utility';
import DoctorProfileForm from './DoctorProfileForm';
import { INVENTROY_CONSTANTS } from './../../../../shared/constants/commonConstants';

const NewDoctorProfile = ({ match: { path } }: any): ReactElement => {
  const [isSubmit, setIsSubmit] = useState(false);
  const [submitAgain, setSubmitAgain] = useState(false);
  const onSubmitClick = (): void => {
    if (isSubmit) {
      setSubmitAgain(true);
      setIsSubmit(false);
    } else {
      setIsSubmit(true);
      setSubmitAgain(false);
    }
  };
  return (
    <div>
      <PageHeader
        backUrl={extractSecondLevelBaseUrl(path) + INVENTROY_CONSTANTS.doctorList}
        pageTitle={INVENTROY_CONSTANTS.newDoctorProfileText}
        rightComponent={
          (): ReactElement => (
            <Row>
              <Col md={24}>
                <div className="text-right">
                  <Button className="btn-form-submit" type="link" onClick={onSubmitClick}> Save</Button></div>
              </Col>
            </Row>
          )
        }
      />
      <div className="ant-tabs-content-holder tab-custom-container">
        <DoctorProfileForm isSubmit={isSubmit} submitAgain={submitAgain} />
      </div>
    </div>
  );
};

export default NewDoctorProfile;
